<template>
  <section class="about-company">
    <div class="input">
      <label
        class="label"
        for="factory_body"
      >{{ $t('body-title') }}</label>
      <textarea
        id="factory_body"
        :value="valueBody"
        @input="$emit('valueBodyChange', $event.target.value)"
        rows="7"
        type="text"
        :placeholder="$t('body-placeholder')"
        :name="`${inputName}[body]`"
      />
    </div>
  </section>
</template>

<script>
    export default {
        name: 'AboutCompany',
        props: {
            valueBody: {},
            inputName: {
                required: true,
                type: String,
            },
        },
    }
</script>

<style scoped>

</style>
